import {Action} from "../../../action/action";
import {isString} from "../../../helper/isString";
import type {CancelBookingAdminState} from "../cancelBookingAdminState";

export const SET_CANCEL_REASON = "SET_CANCEL_REASON";
export class SetCancelReason extends Action<typeof SET_CANCEL_REASON, string> {
  readonly type = SET_CANCEL_REASON;
  protected state: CancelBookingAdminState;

  constructor(state: CancelBookingAdminState, data?: string) {
    super(state, data);
    this.state = state;
  }

  public isValid(): boolean {
    return isString(this.data);
  }

  public isDoable(): boolean {
    return true;
  }
}
